export default function nullToUndefined<T>(obj: { [name in keyof T]: any }): T {
  const filteredEntries = Object.entries(obj).filter(([, v]) => v !== null)
  return (Object.fromEntries(filteredEntries) as unknown) as T
}
